module.exports = __webpack_public_path__ + "img/ISA-Blank-Certificate-2.15847ca8.png";